import SwivuSortColumn from "./SwivuSortColumn.jsx";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { TASK_BUDGET_FIELDS } from "../../other/constants/OtherKeys.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { getCustomGroupRenderer, lineThroughString, showArchiveRecordAlert } from "../../other/utils/utils.jsx";
import { ColumnStore } from "@bryntum/schedulerpro";
import { getIsArchivedForBoard, tagWidget } from "../../other/utils/otherUtils.jsx";
import { getSavedBoardSelection } from "../../react/hooks/useBoards.jsx";

class TaskBudgetTitleColumn extends SwivuSortColumn {

  static get fields() {
    return [
      { name: "swivuListTitle",type: "string", readOnly: true, defaultValue: "Budget ID" },
      { name: "swivuListSearchKey",type: "string", readOnly: true, defaultValue: TASK_BUDGET_FIELDS.budgetTitleDisplayValue },
      { name: "popupCls",type: "array", readOnly: true, defaultValue: ["minimal-gradient-editor", "!w-[auto]", "!resize-none"] },
    ]
  }

  static get $name() {
    return "TaskBudgetTitleColumn";
  }

  static get type() {
    return WIDGET_KEYS.columnTaskBudgetTitle;
  }

  static get defaults() {
    return {
      text: "Budget ID",
      field: TASK_BUDGET_FIELDS.title,
      editor: false,
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      groupRenderer(e) {
        return getCustomGroupRenderer(e, 'accountingNumber');
      },
    };
  }

  onLoad(project, { editorHandler }) {
    this.project = project;
    this.editorHandler = editorHandler;
  }

  get canMultiSelectSwivuList() {
    return false;
  }

  get swivuListItems() {
    const selectedBoard = getSavedBoardSelection();
    const canShowArchivedRecords = getIsArchivedForBoard(selectedBoard.slug);
    return this.project.getCrudStore(STORE_KEYS.taskBudgetStore).query((record) => canShowArchivedRecords || !record.archived, true);
  }

  getSwivuListItemDisplayValue(record) {
    return lineThroughString(record[TASK_BUDGET_FIELDS.budgetTitleDisplayValue], record.archived);
  }

  getSelectedSwivuListItem(record) {
    return record.budgetId;
  }

  onSwivuListSelectionChange(record, selectedRecords) {
    if (selectedRecords.length) {
      record.budgetId = selectedRecords[0].id;
    } else {
      record.budgetId = null;
    }
  }

  renderer({ record }) {
    if (!record.isGroupHeader) {
      return tagWidget(record[TASK_BUDGET_FIELDS.title]);
    }
  }

  onSwivuBeforeListSelectionChange(record, [budgetRecord]) {
    if (showArchiveRecordAlert(record) || showArchiveRecordAlert(budgetRecord)) {
      return false;
    }
    return true;
  }
}

ColumnStore.registerColumnType(TaskBudgetTitleColumn);
